import { Box, MenuItem, Tabs, Tab } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { CustomSelect, CustomButton, HorizontalForm } from '../../../../common/components';

const LotsHeaderControls = ({
  allotments = [],
  selectedAllotment,
  onSelectAllotment,
  view,
  onViewChange,
  onDownloadFullDatabase,
  downloadDisabled = false,
  downloadLoading = false,
  showTableFilters = false,
  referenceStatusOptions = [],
  selectedReferenceStatus = '',
  onReferenceStatusChange,
  contractOptions = [],
  selectedContractFilter = '',
  onContractFilterChange,
}) => {
  const selectEllipsisSx = {
    minWidth: 0,
    '& .MuiSelect-select': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  };

  const desktopColumns = showTableFilters
    ? 'minmax(220px, 250px) minmax(280px, 1fr) minmax(170px, 220px) auto'
    : 'minmax(220px, 320px) auto';

  return (
    <HorizontalForm variant="twoRows">
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: desktopColumns },
          gap: 2,
          alignItems: 'end',
          mb: 2
        }}
      >
        <CustomSelect
          label="Loteo"
          name="uuid_allotment"
          value={selectedAllotment}
          onChange={onSelectAllotment}
          sx={selectEllipsisSx}
        >
          <MenuItem value="">Seleccionar loteo</MenuItem>
          {allotments.map((allotment) => (
            <MenuItem key={allotment.uuid} value={allotment.uuid}>
              {allotment.name}
            </MenuItem>
          ))}
        </CustomSelect>

        {showTableFilters && (
          <CustomSelect
            label="Estado"
            name="reference_status"
            value={selectedReferenceStatus}
            onChange={onReferenceStatusChange}
            sx={selectEllipsisSx}
          >
            {referenceStatusOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </CustomSelect>
        )}

        {showTableFilters && (
          <CustomSelect
            label="Contrato"
            name="contract_filter"
            value={selectedContractFilter}
            onChange={onContractFilterChange}
            sx={selectEllipsisSx}
          >
            <MenuItem value="">Todos</MenuItem>
            {contractOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </CustomSelect>
        )}

        <Box sx={{ display: 'flex', justifyContent: { xs: 'stretch', md: 'flex-end' }, ml: { md: 'auto' } }}>
          <CustomButton
            variant="base"
            buttonIcon={DownloadIcon}
            onClick={onDownloadFullDatabase}
            disabled={downloadDisabled}
            isLoading={downloadLoading}
            sx={{
              width: { xs: '100%', md: 'auto' },
              minWidth: { md: 360 },
              whiteSpace: 'nowrap',
            }}
          >
            Descargar base de datos completa
          </CustomButton>
        </Box>
      </Box>

      <Tabs value={view} onChange={(_, value) => onViewChange(value)}>
        <Tab value="plan" label="Plano" />
        <Tab value="table" label="Tabla" />
        <Tab value="dashboard" label="Dashboard" />
        <Tab value="general-dashboard" label="Dashboard general" />
      </Tabs>
    </HorizontalForm>
  );
};

export default LotsHeaderControls;
